import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { AddSpaceGroupMemberComponent } from "./AddSpaceGroupMemberComponent";
import { AddSpaceGroupMemberUIKitComponent } from "./AddSpaceGroupMemberUIKitComponent";
import type { AddSpaceGroupMemberModalProps } from "./types";

const AddSpaceGroupMemberModalComponent = (
  props: AddSpaceGroupMemberModalProps,
) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  if (isCircleV4) {
    return <AddSpaceGroupMemberComponent {...props} />;
  }

  return <AddSpaceGroupMemberUIKitComponent {...props} />;
};

const AddSpaceGroupMemberModal = ModalManager.create(
  (props: AddSpaceGroupMemberModalProps) => (
    <AddSpaceGroupMemberModalComponent {...props} />
  ),
);

export const useAddSpaceGroupMemberModal = () =>
  useModal(AddSpaceGroupMemberModal);
